import CookiesJS from 'cookies-js';

export function initSubscriptions($, apiClient) {
    $('form.subscription-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const subscription = {
                userId: $('#userId').val(),
                tariffId: $('#tariffId').val(),
                discountPercent: parseInt($('#discountPercent').val()) || 0,
                discountCost: parseInt($('#discountCost').val()) || 0,
                isPaused: !!$('#isPaused').prop('isPaused'),
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/subscriptions', subscription, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/subscriptions/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/subscriptions', _id, subscription, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
